import React, { useState } from "react";
import {Link as ReactRouterLink}  from "react-router-dom";
import {
    Container, 
    Logo, 
    ButtonLink, 
    Background, 
    Link, 
    Search, 
    SearchInput, 
    SearchIcon,
    Group,
    Profile,
    Picture,
    Dropdown,
    Text,
    Feature,
    FeatureCallOut,
    PlayButton
} from "./style/header";


export default function Header({ bg = true, children, ...restProps }){

    return (
        bg ? (
            <Background { ...restProps }>{children}</Background>
        ) : children
        
    )
}

Header.Frame = function HeaderFrame({children, ...restProps}){
    return (<Container {...restProps}>
        {children}
    </Container>)
}

Header.Group = function HeaderGroup({ children, ...restProps}){
    return <Group {...restProps} >{children}</Group>
}

Header.Logo = function HeaderLogo({to, ...restProps}){
    return <ReactRouterLink to={to}>
        <Logo {...restProps} />
    </ReactRouterLink>
}

Header.Link = function HeaderLink({active, children, ...restProps}){
    return <Link {...restProps} active={active} >{children}</Link>
}

Header.Search = function HeaderSearch({ searchTerm, setSearchTerm, ...restProps }){
    const [ searchActive, setSearchActive ] = useState(false);
    return (
        <Search>
            <SearchIcon  onClick={()=> setSearchActive(!searchActive)} >
                <img src="/images/icons/search.png" alt="search" />
            </SearchIcon>
            <SearchInput 
                type="text"
                value={searchTerm} 
                onChange={({ target })=> setSearchTerm(target.value)} 
                placeholder="Search files and series"
                active={searchActive}
            />
            
        </Search>   
    )
}

Header.ButtonLink = function HeaderButtonLink({ children, ...restProps}){
    return <ButtonLink {...restProps}>{children}</ButtonLink>
}

Header.Profile = function HeaderProfile({ children, ...restProps }){
    return <Profile { ...restProps } >{children}</Profile>
}

Header.Picture = function HeaderPicture({ src, children, ...restProps }){
    return <Picture src={`../images/users/${src}.png`} { ...restProps } />
}

Header.Dropdown = function HeaderDropdown({ children, ...restProps }){
    return <Dropdown { ...restProps } >{children}</Dropdown>
}

Header.Feature = function HeaderFeature({ children, ...restProps }){
    return <Feature { ...restProps } >{children}</Feature>
}

Header.FeatureCallOut = function HeaderFeatureCallOut({ children, ...restProps }){
    return <FeatureCallOut { ...restProps } >{children}</FeatureCallOut>
}

Header.Text = function HeaderText({ children, ...restProps }){
    return <Text {...restProps }>{children}</Text>
}


Header.PlayButton = function HeaderPlayButton({ children, ...restProps }){
    return <PlayButton {...restProps} >{children}</PlayButton>
}